<template>
  <ToolsFormTransverseTraction
    :prop-bearing-width="bearingWidth"
    :prop-bearing-length="bearingLength"
    :prop-bearing-thickness="bearingThickness"
    :prop-power="power"
    :disable-inputs="disableInputs"
  />
</template>

<script>
import ToolsFormTransverseTraction from '../../components/tools/ToolsFormTransverseTraction.vue';

export default {
  components: {
    ToolsFormTransverseTraction,
  },
  data() {
    return {
      bearingWidth: this.$store.state.fixedBearingWidth,
      bearingLength: this.$store.state.fixedBearingLength,
      bearingThickness: this.$store.state.fixedBearingThickness,
      power: this.$store.state.fixedBearingPressureForce,
      disableInputs: [
        'bearingWidth',
        'bearingLength',
        'bearingThickness',
        'power',
      ],
    };
  },
};
</script>

<style scoped lang="scss">

</style>
